<template>
<v-card flat>
  <v-system-bar v-if='withHeader' :color='themeColor' status floating dark style='position:inherit;' >
    <v-subheader>{{title}}</v-subheader>
    <v-spacer></v-spacer>
    <v-btn @click="$emit('close')" icon ><v-icon>close</v-icon></v-btn>
  </v-system-bar>
  <v-card-text>
    <transition name='fade' mode='out-in' >
    <keep-alive>
    <component
      :is="activeComponent"
      @clientselected='clientSelected'
      @relationshipselected='relationshipSelected'
      @client:created='clientCreated'
      @componentchanged='setComponent'
      @back='activeComponent="ClientList"'
      :touch='componenttouch'
      :space-id='spaceId'
      :include-owned-by-me='includeOwnedByMe'
      :limit=10
      :can-clear-space='canClearSpace'
      :with-header='false'
      :with-back='true' mode="out-in"
      :show-list-initially='showListInitially'
      :initial='initial' :page='page' :title='title' >
    </component>
    </keep-alive>
    </transition>
  </v-card-text>
</v-card>
</template>

<script>
import ClientList from '@/components/client/ClientList'
import ClientCreate from '@/components/client/Create'

export default {
  name: 'ClientPickerDialog',
  components: {ClientList, ClientCreate},
  props: {
    value: { type: Object },
    initial: { type: Number, default: 10 },
    page: { type: Number, default: 25 },
    spaceId: { required: false },
    includeOwnedByMe: { type: Boolean, default: true },
    withHeader: { type: Boolean, default: true },
    showListInitially: { type: Boolean, default: true },
    canClearSpace: { type: Boolean, default: true },
    title: { type: String, default: 'Choose a client' },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      activeComponent: ClientList,
      searchString: '',
      componenttouch: 1
    }
  },
  mounted () {
    this.limit = this.initial
  },
  methods: {
    reset () {
      this.activeComponent = ClientList
      this.searchString = ''
    },
    clientSelected (client) {
      this.$emit('clientselected', client)
      this.$emit('input', client)
    },
    relationshipSelected (rel) {
      this.$emit('relationshipselected', rel)
    },
    setComponent (component) {
      this.componenttouch++
      this.activeComponent = component
    },
    clientCreated (client) {
      this.$emit('relationshipselected', client)
      if (client.client) { client = client.client }
      this.$emit('clientselected', client)
      this.$emit('input', client)
      setTimeout(() => {
        this.activeComponent = 'ClientList'
        // this.getClients()
      }, 100)
    }
  },
  watch: {
    touch () {
      this.componenttouch++
      this.reset()
    }
  },
  computed: {
    clients () {
      return this.$store.getters.clients
    },
    filteredClients () {
      let clients = this.clients
      let vm = this
      if (vm.searchString && vm.searchString.length > 0) {
        clients = clients.filter((clientRel) => {
          if (clientRel.client) {
            let client = clientRel.client
            let index = `${client.first_name} ${client.last_name} ${client.email} ${client.phone_number}`
            return (index.toLowerCase()).indexOf(vm.searchString.toLowerCase()) !== -1
          }
        })
      }
      return clients.slice(0, this.limit)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientPickerDialog.vue?570a1b7e